import { Loading } from '@beamery/lib-ds-icons';
import styled, { css, keyframes } from 'styled-components';
export const rotate = keyframes `
from {
  transform: translate(-50%, -50%) rotate(0deg)
}
to {
  transform: translate(-50%, -50%) rotate(360deg)
}
`;
export const LoadingSpinnerElement = styled(Loading)(({ theme }) => css `
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    animation: ${rotate} 1.15s ${theme.transitions.easing['ease-in-out']}
      infinite;
  `);
//# sourceMappingURL=loading-spinner.styles.js.map